<template>
  <div class="group">
    <HeaderReturn title="我的认购">
      <template #left>
        <!-- <slot name="right">
                    <van-icon name="arrow-left" color="#fff" @click="goLink('/My')"/>
                </slot> -->
      </template>
      <template #right>
        <slot name="right">
          <span
            @click="goLink('/Subscription/addToSubs')"
            style="color: #f89b19"
            >我要认购</span
          >
        </slot>
      </template>
    </HeaderReturn>
    <div class="property">
      <!-- <div @click="goLink('/Subscription/record')" style="padding: 20px 10px 0 10px;">通证管理: 651.6000 ></div> -->
      <ul>
        <li>
          待结通证：<span>{{ Number(treatAmount).toFixed(4) }}</span>
        </li>

        <li>
          我的通证总额度：<span>{{ Number(sum).toFixed(4) }}</span>
        </li>
        <li>
          已释放额度(USDT）：<span>{{ Number(released).toFixed(4) }}</span>
        </li>
        <li class="d-flex">
          <div style="color: #f89b19">昨日释放：</div>
          <div>
            <span>{{ Number(yesterdayRelease).toFixed(4) }}</span>
            <p>≈{{ Number(yesterdayReleaseYd).toFixed(4) }} USDT</p>
          </div>
        </li>
        <li></li>
      </ul>

      <div class="dghkjds">
        <!-- <van-button
          loading-text="加载中..."
          :loading="Isloading"
          @click="allSignInClick"
          type="primary"
        >
          <p :class="isReceiveIs == false ? 'hjkfsd' : 'dsflk'">全部领取</p>
        </van-button> -->
        <!-- 全部领取 -->
      </div>
    </div>
    <!-- <div class="income_tabs">
            <van-tabs type="card" v-model="activeName" @change="ChangeClick">
                <van-tab title="全部" name="0"></van-tab>
                <van-tab title="释放中" name="1"></van-tab>
                <van-tab title="已释放" name="2"></van-tab>
            </van-tabs>
        </div> -->
    <div class="income_tabs_2">
      <div
        @click="div_click(`0`)"
        :class="activeName == `0` ? `my_active` : ``"
      >
        全部
      </div>
      <div
        @click="div_click(`1`)"
        :class="activeName == `1` ? `my_active` : ``"
      >
        释放中
      </div>
      <div
        @click="div_click(`2`)"
        :class="activeName == `2` ? `my_active` : ``"
      >
        已释放
      </div>
    </div>
    <div class="Assets_ul">
      <ul>
        <van-list
          v-model:loading="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="到底啦~"
          @load="onLoad"
        >
          <li
            v-for="(item, index) in AccasetList"
            :key="index"
            @click.stop="goLink('/Subscription/particulars', item)"
          >
            <div class="d-flex justify-between Assets_Num">
              <div>
                <p>订单编号</p>
                <p style="margin-top: 2px; color: #f89b19">
                  {{ item.orderId }}
                </p>
                <div class="dfbsk">
                  {{ item.status == 0 ? "释放中" : "已释放" }}
                </div>
              </div>
              <div class="d-flex Assets_btn">
                <!-- <van-button
                  loading-text="加载中..."
                  :loading="Isloading"
                  @click.stop="signInClcik(item)"
                  type="primary"
                >
                  <p :class="item.isReceive == 0 ? 'fdlk' : 'fuiofd'">签到</p>
                </van-button> -->
                <!-- <div :class="item.isReceive == 0 ? 'fdlk' : 'fuiofd'">签到</div> -->
                <van-icon
                  name="arrow"
                  size="18"
                  color="#f89b19"
                />
              </div>
            </div>

            <div class="Assets_grid fn-16" style="color: #f89b19">
              <p>{{ item.passLimit }}</p>
              <p>{{ item.addUpRelease }}</p>
              <p style="text-align: center">{{ item.yesterdayRelease }}</p>
            </div>

            <div
              class="Assets_grid"
              style="color: #9c9c9c; font-size: 12px; padding-bottom: 15px"
            >
              <p>通证额度(USDT)</p>
              <p>累计释放(USDT)</p>
              <p style="text-align: center">昨日释放(LQD)</p>
            </div>
            <!-- <div>
                        <p>{{ item.value }}</p>
                        <p>{{ item.value }}</p>
                        <p>{{ item.value }}</p>
                    </div>
                    <div>
                        <p>可用余额</p>
                        <p>冻结</p>
                    </div> -->
          </li>
        </van-list>
      </ul>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar, Icon, Button } from "vant";
Vue.use(NoticeBar).use(Icon).use(Button);
import vueQr from "vue-qr";
import { mainApiData } from "@/request/api.js";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      Isloading: false,
      baseApi: "",
      UrlYqhy: "",
      Aeccter: {
        money: 75.8193,
      },
      TeamList: [
        {
          url: require("../../assets/img/page/mm.png"),
          txt: "充值",
          id: 0,
          path: "/My/recharge",
        },
        {
          url: require("../../assets/img/page/aq.png"),
          txt: "提币",
          id: 1,
          path: "/My/withdrawal",
        },
        {
          url: require("../../assets/img/page/bf.png"),
          txt: "闪兑",
          id: 2,
          path: "/My/flashExchange",
        },
      ],
      AccasetList: [],
      performanceList: {
        total: 99999,
        region: 77777,
        plot: 33333,
      },
      loading: false,
      finished: false,
      pageNo: 0,
      pageSize: 10,
      activeName: "0",
      released: 0,
      sum: 0,
      yesterdayRelease: 0,
      yesterdayReleaseYd: 0,
      treatAmount: 0,
      isReceiveIs: false,
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.UrlYqhy = window.location.origin + "/#/reg?promotion=" + "1111";
    this.onLoad();
    this.Init();
    let that = this;
    setInterval(() => {
      //that.Init();
    }, 2000);
  },
  methods: {
    signInClcik(val) {
      this.Isloading = true;
      if (val.isReceive == 0) {
        this.Isloading = false;
        // 暂未开放
        return this.$toast(this.$t("orePond.a42"));
      }
      mainApiData.signIn(val.id).then((res) => {
        if (res.data.code == 200) {
          this.$toast("签到成功");
        } else {
          this.$toast(res.data.msg || res.data.data);
        }
        this.ChangeClick();
        this.Isloading = false;
      });
    },
    allSignInClick() {
      this.Isloading = true;
      if (this.isReceiveIs == false) {
        this.Isloading = false;
        // 暂未开放
        return this.$toast('未到领取时间');
      }
      mainApiData.allSignIn().then((res) => {
        if (res.data.code == 200) {
          this.$toast("全部领取成功");
        } else {
          this.$toast(res.data.msg || res.data.data);
        }
        this.ChangeClick();
        this.Isloading = false;
      });
    },
    div_click(index) {
      this.activeName = index;
      console.log(index, this.activeName);
      this.ChangeClick();
    },
    ChangeClick(val) {
      this.loading = false;
      this.AccasetList = [];
      this.finished = false;
      this.pageNo = 0;
      this.pageSize = 10;
      this.onLoad();
    },
    Init() {
      mainApiData.statis().then((res) => {
        this.released = res.data.data.released;
        this.treatAmount = res.data.data.treatAmount;
        this.sum = res.data.data.sum;
        this.yesterdayRelease = res.data.data.yesterdayRelease;
        this.yesterdayReleaseYd =
          res.data.data.yesterdayRelease * res.data.data.lastPrice;
      });
    },
    checkIfIsReceiveOne(arr) {
      for (let item of arr) {
        if (item.isReceive === 1) {
          this.isReceiveIs = true;
        }
      }
      this.isReceiveIs = false;
    },
    onLoad() {
      this.pageNo++;
      let parme = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        status: this.activeName == 0 ? "" : this.activeName == 1 ? "0" : "1",
      };
      mainApiData.getPageSubOrder(parme).then((res) => {
        if (res.data.code == 200) {
          for (let i = 0; i < res.data.data.records.length; i++) {
            this.AccasetList.push(res.data.data.records[i]);
          }
          this.total = res.data.total;
        }
        for (let item of this.AccasetList) {
          if (item.isReceive === 1) {
            this.isReceiveIs = true;
          } else {
            this.isReceiveIs = false;
          }
        }
      });
      this.loading = false;
      if (this.AccasetList.length >= this.total) {
        this.finished = true;
      }
    },
    onCopy() {
      this.$toast(this.$t("myself.a23"));
    },
    goLink(path, item) {
      if (path) {
        this.$router.push({
          path,
          query: {
            item: JSON.stringify(item),
          },
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";
::v-deep .van-nav-bar__title {
  color: #f89b19 !important;
  font-size: 20px;
  font-weight: 600;
}
.group {
  margin: 50px 10px;

  ::v-deep .van-nav-bar__title {
    color: #f89b19;
  }

  .property {
    display: flex;
    justify-content: space-between;
    // width: 90%;
    margin: 15px 0px;
    padding: 10px 10px;
    .dghkjds {
      margin: 5px 5px;
      :deep(.van-button) {
        background: transparent;
        border: 0;
        width: 80px;
        color: #9c9c9c;
      }
      :deep(.van-button::before){
              background: transparent;
            }
    }
    .dsflk {
      width: 80px;
      padding: 3px 25px;
      // margin-right: 10px;
      // box-shadow: 0 0 0 0.5px rgba(2, 150, 236, 1);
      border-radius: 4px;
      color: #f89b19;
      font-size: 12px;
      text-align: center;
      border-radius: 5px;

      border: 0.5px solid #f89b19;
      line-height: 17px;

      height: 25px;
    }
    .hjkfsd {
      width: 80px;
      line-height: 17px;
      padding: 3px 15px;
      margin-right: 10px;
      box-shadow: 0 0 0 0.5px rgba(2, 150, 236, 1);
      border-radius: 4px;
      color: #9c9c9c;
      font-size: 12px;
      text-align: center;
      border-radius: 5px;
      border: 0.5px solid;
      border-image-source: linear-gradient(
        91.24deg,
        #1484c3 0.21%,
        #1db4bd 51.69%,
        #1484c3 99.06%
      );

      height: 25px;
    }

    // height: 158px;

    // background: url(../../assets/img/page/hh.png) no-repeat;
    // background-size: 100% 100%;
    background: url(../../assets/img/page/ZC-345X180.png) no-repeat;
    background-size: 100% 100%;
    ::v-deep .number-grow {
      color: #fff !important;
      font-size: 20px;
    }

    ::v-deep .number-grows {
      color: #fff !important;
      font-size: 16px;
      margin-top: 3px;
      display: block;
    }

    div {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */

      /* 白/FE */

      color: #fefefe;

      &:nth-child(1) {
        // padding: 20px 10px 0 10px;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */
        text-align: right;
        color: #003e62;

        // ::v-deep .numsp {

        //     font-size: 15px !important;
        //     border: 1px solid red;
        // }
      }
    }

    ul {
      li {
        padding: 10px 10px 0 10px;
        color: #f89b19;

        span {
          color: rgba(255, 255, 255, 1);
          font-size: 16px !important;
          // border: 1px solid red;
        }

        &:nth-child(4) {
          padding-bottom: 10px;
          display: flex;

          p {
            color: #d6d6d6;
          }
        }
      }
    }
  }

  .income_tabs {
    margin-top: 30px;

    ::v-deep .van-tab.van-tab--active {
      background: rgba(20, 132, 195, 0.5);
    }

    ::v-deep .van-tabs__nav--card {
      background: rgba(20, 132, 195, 0.2);
    }

    ::v-deep .van-tabs__nav {
      border-radius: 4px;
    }
  }
  .income_tabs_2 {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    div {
      width: 27%;
      border-radius: 4px;
      background: transparent;
      padding: 5px;
      text-align: center;
      font-size: 14px;
      color: var(--fe, #fefefe);
      border: 0.5px solid #f89b19;
    }
    .my_active {
      background: #f89b19;
      font-size: 16px;
    }
    // div:last-child{
    //     margin-right: 0px;
    //     margin-left: 30px;
    // }
  }

  .Assets_ul {
    overflow: hidden;
    height: 550px;
    overflow-y: scroll;
    .dfbsk {
      padding: 3px 0px;

      border-radius: 4px;
      color: #fff;
      font-size: 12px;

      border-radius: 2px;
    }
    ul {
      li {
        margin: 20px 10px;
        // background: rgba(20, 132, 195, 0.2);
        /* 黄/主题 */

        border: 0.5px solid #f89b19;
   
        border-radius: 4px;

        .Assets_Num {
          padding: 15px 10px;

          .Assets_btn {
            // border: 1px solid red;
            :deep(.van-button) {
              background: transparent;
              border: 0;
              height: 25px;
              // width: 80px;
            }
            :deep(.van-button::before){
              background: transparent;
            }
            padding: 7px 0;
            .fdlk {
              padding: 3px 15px;
              margin-right: 10px;
              box-shadow: 0 0 0 0.5px rgba(2, 150, 236, 1);
              border-radius: 4px;
              color: #9c9c9c;
              font-size: 12px;
              text-align: center;
              border-radius: 2px;
              border: 0.5px solid;

              border-image-source: linear-gradient(
                91.24deg,
                #1484c3 0.21%,
                #1db4bd 51.69%,
                #1484c3 99.06%
              );

              height: 25px;
            }
            .fuiofd {
              padding: 3px 15px;
              margin-right: 10px;
              box-shadow: 0 0 0 0.5px rgba(2, 150, 236, 1);
              border-radius: 4px;
              color: #f89b19;
              font-size: 12px;
              text-align: center;
              border-radius: 2px;
              border: 0.5px solid;
              border: 0.5px solid #f89b19;

              height: 25px;
            }

            // div {
            //   padding: 3px 15px;
            //   margin-right: 10px;
            //   box-shadow: 0 0 0 0.5px rgba(2, 150, 236, 1);
            //   border-radius: 4px;
            //   color: #f89b19;
            //   font-size: 12px;
            //   text-align: center;
            //   border-radius: 2px;
            //   border: 0.5px solid var(--unnamed, #f89b19);
            // }

            ::v-deep .van-icon {
              font-size: 18px;
              margin-top: 2px;
            }
          }
        }

        .Assets_grid {
          display: grid;
          justify-content: space-between;
          grid-template-columns: 33% 33% 33%;
          // text-align: center;
          padding: 5px 10px;
        }

        // div {
        //   padding: 5px 10px;

        //     div{
        //         // display: flex;
        //         // justify-content: space-between;
        //         &:nth-child(2){
        //             display: flex;

        //             // border: 1px solid red;
        //             div{
        //                 // padding: 5px 10px;
        //                 // height:20px;

        //                 border: 1px solid red;
        //             }
        //             ::v-deep .van-icon{
        //                 font-size: 18px;
        //                 border: 1px solid red;
        //             }
        //         }
        //     }
        // }
      }
    }
  }
}
</style>
